import React, { useState } from 'react';
import PropTypes from 'prop-types';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import HoursDay from 'locations/components/HoursDay';

const Hours = ({ data, label }) => {
  const [isOpen, toggleOpen] = useState(false);
  const Icon = isOpen ? KeyboardArrowUp : KeyboardArrowDown;
  const ToggleHoursButton = (
    <IconButton
      data-testname="toggle-hours"
      onClick={() => toggleOpen(!isOpen)}
      style={{ padding: 0 }}
    >
      <Icon />
    </IconButton>
  );
  const todayAdornment = !isOpen ? ToggleHoursButton : undefined;
  return (
    <div>
      <HoursDay
        label={label}
        hours={data.today.hours}
        adornmentEnd={todayAdornment}
        dataTestId="today-display-hours"
      />

      <Collapse in={isOpen}>
        <List>
          {data.weekday_hours.map((dayRange, idx, arr) => {
            const isLast = idx === arr.length - 1;
            const adornmentEnd = isLast ? ToggleHoursButton : undefined;
            return (
              <ListItem key={dayRange.days} dense style={{ display: 'block' }}>
                <HoursDay
                  dataTestId="week-display-hours"
                  label={dayRange.days}
                  hours={dayRange.hours}
                  adornmentEnd={adornmentEnd}
                />
              </ListItem>
            );
          })}
        </List>
      </Collapse>
    </div>
  );
};

Hours.propTypes = {
  data: PropTypes.shape({
    hours: PropTypes.array,
    weekday_hours: PropTypes.array
  }),
  label: PropTypes.string.isRequired
};

export default Hours;
